export default {
  csvReady: {
    id: 'bo_seller-options-batch_listing_creation-csv_ready',
    defaultMessage: 'Your CSV file is ready for action.',
  },
  downloadButton: {
    id: 'bo_seller-options-batch_listing_creation-download_button',
    defaultMessage: 'Download CSV file',
  },
  completeCsv: {
    id: 'bo_seller-options-batch_listing_creation-complete_csv',
    defaultMessage:
      'Complete the following fields for each listing you add in the CSV file.',
  },
}
